/**
 * Bookmarks
 *
 * @component bookmarks
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';

class Bookmarks {

    constructor(){
        let self = this;
        self.logger = ClassLogger(self, true);

        self.options = {
            cacheTTL: 60*5*1000, // in milliseconds
            cacheKey: 'hierbleiben.bookmarks.jobs'
        };

        self.init();
    }

    init() {

        let self = this;
        
        // remove all previous click handlers
        $('[data-bookmark-button]').off('click');

        $('[data-bookmark-button]').on('click', function(event){
            let $button = $(this);
            let params = {};
            params.jobid = $(event.currentTarget).data('jobid');
            params.bookmarkId = $(event.currentTarget).data('bookmarkid');
            params.method = $(event.currentTarget).data('bookmark-button');

            let uri = '/accounts/me/bookmarks';
            let method = params.method.toLowerCase() === 'delete' ? 'DELETE' : 'POST';

            let data = {
                'type': 'job',
                'targetid': params.jobid,
                'date': new Date().toISOString()
            };

            if (method === 'DELETE' && params.bookmarkId !== undefined) {
                data = [];
                uri = uri + '/jobs/'+ params.bookmarkId;
            }

            window.e('Jobs', method === 'POST' ? 'bookmark-add' : 'bookmark-delete', params.jobid);

            self.logger.log(method+' '+uri, data);

            let buttonBackup = $button.html();
            $button.html();
            $('#javascripthelpers .c-preloader-overlay').clone().appendTo($button).show();

            // Request Data
            Api.request(method, uri, data)
            .then(function(response) {
                $button.html(buttonBackup);
                if (method === 'DELETE') {
                    self.markUnbookmarked(params.jobid);
                } else {
                    self.markBookmarked(params.jobid, response.data.id);
                }

                self.regenerateCache();

            }).catch(function(exception){
                let error_message = 'Es trat ein Fehler auf!';
                if (typeof exception === 'object'
                    && typeof exception.responseJSON === 'object'
                    && typeof exception.responseJSON.error_code !== 'undefined'
                    && typeof exception.responseJSON.error_message === 'string'
                ) {
                    error_message = exception.responseJSON.error_message;
                }
                alert(error_message);
                $button.html(buttonBackup);
            });
        });

        // Go through bookmark buttons
        if ($('[data-bookmark-button][data-jobid][data-jobid!=""]').length) {
            self.getData().then(function(data){
                self.logger.log('Got data for bookmarks. Now marking bookmarks.', data);
                data.bookmarks.forEach(bookmark => {
                    self.markBookmarked(bookmark.target.id, bookmark.id);
                });
            }).catch(function(err){
                self.logger.error('Could not get bookmarks data', err);
            });
        }

    }


    markBookmarked(jobId, bookmarkId) {
        let self = this;
        //self.logger.log('marking job '+jobId+' as bookmarked');
        let $button = $('[data-bookmark-button][data-jobId="'+jobId+'"]');
        if ($button.length === 0) return;
        $button.data('bookmarkid', bookmarkId);
        $button.data('bookmark-button', 'delete');
        $button.find('.c-button__label').text(window.siteconfig.dictionary.delete_from_bookmarks);
    }


    markUnbookmarked(jobId) {
        let $button = $('[data-bookmark-button][data-jobId="'+jobId+'"]');
        if ($button.length === 0) return;
        $button.data('bookmark-button', 'add');
        $button.data('bookmarkid', '');
        $button.find('.c-button__label').text(window.siteconfig.dictionary.add_to_bookmarks);
        // remove block from bookmark list (if there is a bookmark list...)
        $('[data-bookmarklist] .c-jobblock[data-id="'+ jobId +'"]').slideUp(400, function(){$(this).remove();});
    }


    /**
     * getData
     * get event data from cache or server
     *
     * @returns promise
     */
    getData() {
        let self = this;

        return new Promise((resolve, reject) => {
            let data = this.getDataFromCache();
            if (data !== null) {
                self.logger.log('got cached data', data);

                // check if we should request new data from the server
                if (data.downloadedon < (Date.now() - self.options.cacheTTL)) {
                    self.debug && window.console &&  console.info('Data is outdated. Should request new data from server. This will happen in the background. We\'ll continue using our outdated data');
                    this.requestData().catch(function(err){
                        reject(err);
                    });
                    return resolve(data);
                }

                // otherwise return cached data
                return resolve(data);
            }

            this.requestData().then(resolve, reject);
        });
    }


    requestData() {
        let self = this;
        self.logger.log('Requesting data from server');

        return Api.request('GET', '/accounts/me/bookmarks/job')
            .then(function(response) {
                self.logger.log('got data from server', response);
                if (typeof response.data !== 'object') {
                    self.logger.error('Response error', response);
                    throw new Error('Server response was not successful');
                }
                let data = {downloadedon: Date.now(), bookmarks: response.data};
                self.writeDataToCache(data);
                return data;

            }, function(jqXHR){
                self.logger.error('Request error: '+jqXHR.status+' - '+jqXHR.statusText, jqXHR);
                throw jqXHR;
            });
    }


    writeDataToCache(data) {
        this.logger.log('saving data to cache', data);
        window.localStorage.clear();
        this.setStorageObject(this.options.cacheKey, data);
    }


    getDataFromCache() {
        return this.getStorageObject(this.options.cacheKey);
    }

    regenerateCache() {
        window.localStorage.removeItem(this.options.cacheKey);
        this.requestData();
    }


    /**
     * setStorageObject
     * saves an object as JSON to localStorage
     */
    setStorageObject(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }


    /**
     * getStorageObject
     * returns object from localStorage or NULL if not found
     *
     * @param key
     * @return object | null
     */
    getStorageObject(key) {
        let value = window.localStorage.getItem(key);
        return value && JSON.parse(value);
    }
}

export default new Bookmarks();
